module.exports = __webpack_public_path__ + "static/media/vitalMobile1.17805e0a.svg";